(() => {
  const input = document.querySelector('[data-search-input]');
  const results = document.querySelector('[data-search-results]');
  const defaults = document.querySelector('[data-search-default]');
  const recent = document.querySelector('[data-recent-searches]');
  if (!input || !results || !defaults || !recent) return;

  let timer;
  let request;
  const escapeHTML = (value = '') => { const el = document.createElement('div'); el.textContent = value; return el.innerHTML; };
  const money = cents => {
    const format = window.theme?.moneyFormat || '${{amount}}';
    return format.replace(/\{\{\s*amount[^}]*\}\}/, (Number(cents || 0) / 100).toFixed(2)).replace(/<[^>]*>/g, '');
  };
  const savedSearches = () => { try { return JSON.parse(localStorage.getItem('atelier-searches') || '[]'); } catch (_) { return []; } };
  const renderRecent = () => {
    const searches = savedSearches();
    recent.hidden = !searches.length;
    recent.innerHTML = searches.length ? `<p>Recent searches</p>${searches.map(term => `<button type="button" data-search-term="${escapeHTML(term)}">${escapeHTML(term)}</button>`).join('')}` : '';
  };
  const remember = query => {
    const searches = [query, ...savedSearches().filter(term => term.toLowerCase() !== query.toLowerCase())].slice(0, 5);
    localStorage.setItem('atelier-searches', JSON.stringify(searches));
  };
  const clear = () => {
    if (request) request.abort();
    results.innerHTML = '';
    results.setAttribute('aria-busy', 'false');
    defaults.hidden = false;
    renderRecent();
  };
  const search = async query => {
    if (query.length < 2) return clear();
    if (request) request.abort();
    const controller = new AbortController();
    request = controller;
    defaults.hidden = true;
    results.setAttribute('aria-busy', 'true');
    results.innerHTML = '<p>Searching...</p>';
    try {
      const url = `${window.theme.routes.predictive}.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last`;
      const response = await fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Search request failed');
      const products = (await response.json()).resources.results.products || [];
      if (request !== controller) return;
      results.innerHTML = products.length ? products.map(product => `<a class="search-result" href="${product.url}"><img src="${product.featured_image?.url ? `${product.featured_image.url}&width=400` : ''}" alt="${escapeHTML(product.featured_image?.alt || product.title)}" loading="lazy"><h3>${escapeHTML(product.title)}</h3><span>${money(product.price)}</span></a>`).join('') : `<p>No products found for “${escapeHTML(query)}”.</p>`;
      remember(query);
    } catch (error) {
      if (error.name !== 'AbortError' && request === controller) results.innerHTML = '<p>Search is temporarily unavailable. Please try again.</p>';
    } finally {
      if (request === controller) results.setAttribute('aria-busy', 'false');
    }
  };

  document.addEventListener('input', event => {
    if (event.target !== input) return;
    event.stopImmediatePropagation();
    clearTimeout(timer);
    timer = setTimeout(() => search(input.value.trim()), 180);
  }, true);
  document.addEventListener('click', event => {
    if (event.target.closest('[data-open-search]')) renderRecent();
    const term = event.target.closest('[data-search-term]');
    if (!term || !recent.contains(term)) return;
    input.value = term.dataset.searchTerm || term.textContent.trim();
    input.dispatchEvent(new Event('input', { bubbles: true }));
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') clear(); });
  renderRecent();
})();
